export default {
    configuration: false,
    'searchList': {
        'searchTxt': [{
            'name': '车牌号',
            'value': 'licensePlateNo',
            'type': 'input',
            'unfold': true,
            'span': 3,
            'multiple': false
        },
        {
            'label': '设备号',
            'prop': 'deviceNo',
            'width': '200px'
        },
        {
            'name': '车辆状态',
            'value': 'enableFlag',
            'type': 'select',
            'unfold': true,
            'span': 3,
            'options': [
                {
                    value: '0',
                    label: '启用'
                },
                {
                    value: '1',
                    label: '停用'
                }
            ],
            'multiple': false
        },
        {
            'name': '常用司机一',
            'value': 'commonDriver',
            'type': 'input',
            'unfold': true,
            'span': 3,
            'multiple': false
        },
        {
            name: '复核状态',
            value: 'reviewStatusList',
            type: 'select',
            unfold: true,
            span: 3,
            multiple: true,
            optionNum: 'SRM_DRIVER_CAR_REVIEW_STATUS',
        },],
        'unfoldState': false,
        'advancedBtn': false
    },
    'table': {
        'switchType': true,
        'tableCut': false,
        'clickState': false,
        'selectBtn': true,
        'height': 300,
        'columns': [
            {
                'label': '车牌号',
                'prop': 'licensePlateNo',
                'width': '140px'
            },
            {
                'label': '整备质量（KG）',
                'prop': 'grossWeight',
                'width': '140px'
            },
            {
                'label': '车型',
                'prop': 'lengthNameCn',
                'width': '140px'
            },
            {
                'label': '是否启用',
                'prop': 'enableFlag',
                'width': '120px'
            },
            {
                'label': '审批状态',
                'prop': 'approvalStatus_',
                'width': '120px'
            },
            {
                label: '复核状态',
                prop: 'reviewStatus_',
                width: '100px',
            },
            {
                label: '复核不通过原因',
                prop: 'reviewFailReason',
                width: '180px',
            },
            {
                'label': '车辆所有人',
                'prop': 'carOwner',
                'width': '200px'
            },
            {
                'label': '常用司机一',
                'prop': 'commonDriver',
                'width': '160px'
            },
            {
                'label': '常用司机手机号码',
                'prop': 'commonDriverPhone',
                'width': '170px'
            },
            {
                'label': '车辆归属',
                'prop': 'carOwnerType',
                'width': '120px'
            }],
        'allColumns': [
            {
                'label': '车牌号',
                'prop': 'licensePlateNo',
                'width': '140px'
            },
            {
                'label': '整备质量（KG）',
                'prop': 'grossWeight',
                'width': '140px'
            },
            {
                'label': '车型',
                'prop': 'lengthNameCn',
                'width': '140px'
            },
            {
                'label': '装载方量（m³）',
                'prop': 'loadingVolume',
                'width': '120px'
            },
            {
                'label': '是否启用',
                'prop': 'enableFlag',
                'width': '120px'
            },
            {
                'label': '审批状态',
                'prop': 'approvalStatus_',
                'width': '120px'
            },
            {
                label: '复核状态',
                prop: 'reviewStatus_',
                width: '100px',
            },
            {
                label: '复核不通过原因',
                prop: 'reviewFailReason',
                width: '180px',
            },
            {
                'label': '车辆所有人',
                'prop': 'carOwner',
                'width': '200px'
            },
            {
                'label': '常用司机一',
                'prop': 'commonDriver',
                'width': '160px'
            },
            {
                'label': '常用司机手机号码',
                'prop': 'commonDriverPhone',
                'width': '170px'
            },
            {
                'label': '车辆归属',
                'prop': 'carOwnerType',
                'width': '120px'
            }],
        'action':
            [{
                'type': 'text',
                'label': '查看附件',
                'size': 'mini',
                'event': 'attachment',
                'ifHas': '08000405'
            },
            {
                'type': 'text',
                'label': '特权复制',
                'size': 'mini',
                'event': 'copy',
                'ifHas': '08000406'
            },
            {
                'type': 'text',
                'label': '审批详情',
                'size': 'mini',
                'event': 'approve',
                'ifHas': '08000407'
            }],
        'leftOperation': true,
        'leftWidth': 220
    },
    'page': {
        'layout': 'total, sizes, prev, pager, next, jumper',
        'pageSize': 10
    }
};
